<template>
  <main>
    <div
      id="app"
      :data-locale="formattedLocale"
      @open-quickshop="DialogQuickshop.open({ product: $event.detail, gtmConfig: { appSource: 'backpack-finder' } })"
    />
    <dialog-quickshop />
  </main>
</template>

<script lang="ts" setup>
const { dialogOptions } = useAppConfig().pages.finders
const { $feature } = useNuxtApp()
const formattedLocale = useFormattedLocale()
if ($feature.configExternalApps.backpackFinderUrl) {
  useScriptTag(
    $feature.configExternalApps.backpackFinderUrl,
    undefined,
    {
      attrs: {
        fetchpriority: 'high'
      }
    }
  )
}

useHead({
  bodyAttrs: {
    class: 'hide-chat-button'
  }
})

const DialogQuickshop = createDialog('quickshop', dialogOptions)

onMounted(() => setInteractionOrigin('backpack-finder'))
</script>
